export const COMPANY_PRODUCT_CREATE_RESET = 'COMPANY_PRODUCT_CREATE_RESET'
export const COMPANY_PRODUCT_CREATE_SET_CREATED = 'COMPANY_PRODUCT_CREATE_SET_CREATED'
export const COMPANY_PRODUCT_CREATE_SET_ERROR = 'COMPANY_PRODUCT_CREATE_SET_ERROR'
export const COMPANY_PRODUCT_CREATE_SET_VIOLATIONS = 'COMPANY_PRODUCT_CREATE_SET_VIOLATIONS'
export const COMPANY_PRODUCT_CREATE_TOGGLE_LOADING = 'COMPANY_PRODUCT_CREATE_TOGGLE_LOADING'
